import { Component, Input } from '@angular/core';
import { PackageInstance } from '@lc/core';
import { MatListItem } from '@angular/material/list';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { BadgeDirective } from '../../../core/directives/badge.directive';

@Component({
  selector: 'lc-package-menu-item',
  templateUrl: './package-menu-item.component.html',
  styleUrls: ['./package-menu-item.component.scss'],
  imports: [
    MatListItem,
    MatTooltip,
    BadgeDirective,
    MatIcon,
    MatIconButton,
    RouterLink,
  ],
})
export class PackageMenuItemComponent {
  @Input() package: PackageInstance;
  @Input() isExpanded: boolean = true;
  @Input() isVIP: boolean;

  @Input() editLink: string | any[];
  @Input() replaceUrl: boolean;
}
